import Component from '@glimmer/component';

import { registerDestructor } from '@ember/destroyable';
import { concat } from '@ember/helper';
import { action } from '@ember/object';
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import { service } from '@ember/service';

import classMod from 'rise-ui/helpers/class-mod.js';
import isTrue from 'rise-ui/helpers/is-true.js';
import not from 'rise-ui/helpers/not.js';
import or from 'rise-ui/helpers/or.js';

const randomChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ01234567890';
function randomString(length, chars = randomChars) {
  let result = '';
  while (result.length < length) {
    result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
  }
  return result;
}

export default class StickyComponent extends Component {
  @service sticky;

  element;
  name = this.args.name || randomString(32);

  constructor() {
    super(...arguments);

    registerDestructor(this, () => {
      this.remove();
    });
  }

  add() {
    this.sticky.add(this.element, this.name, this.args.pause);
  }

  remove() {
    this.sticky.remove(this.element, this.name);
  }

  @action onInsert(el) {
    this.element = el;
    this.add();
  }

  @action onDisableChange(disabled) {
    if (disabled) {
      this.remove();
    } else {
      this.add();
    }
  }

  <template>
    {{#if (not (isTrue @disabled))}}
      <div class={{classMod "c-sticky" @type (concat "--" @type)}}
        {{didInsert this.onInsert}}
        {{didUpdate this.onDisableChange @disabled}}
        ...attributes
      >
        <div class="c-sticky-wrapper">
          {{#if (has-block "left")}}
            <div class="c-sticky__left">
              {{yield to="left"}}
            </div>
          {{/if}}
          {{#if (or (has-block) (has-block "content"))}}
            <div class="c-sticky__content {{if (has-block "left") "c-sticky__content--center"}}">
              {{yield to="content"}}
              {{yield}}
            </div>
          {{/if}}
          {{#if (has-block "right")}}
            <div class="c-sticky__right">
              {{yield to="right"}}
            </div>
          {{/if}}
        </div>
      </div>
    {{/if}}
  </template>
}
